// extracted by mini-css-extract-plugin
export default {"progressBarContainer":"FloatingLinearProgress_progressBarContainer__1Z9Jl"};